import { Component,
    Input,
    ElementRef,
    Renderer,
    OnChanges,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { TreeComponent, TreeService, TreeNode } from '../../../../../common/tree';
import { ContextMenuHolderComponent
} from '../../../../../common/context-menu/context-menu-holder.component';
import { ContextMenuService } from '../../../../../common/context-menu/context-menu.service';
import { ContextMenuDirective } from '../../../../../common/context-menu/context-menu.directive';
import { ServiceHeaderDirective } from '../../../service-header/service-header.directive';
import { InventoryService } from '../../services/inventory.service';
import { Subscription } from 'rxjs/Rx';
import { Autofocus } from '../../../../../common/auto-focus/auto-focus.directive';
const _ = require('lodash');
import { Router, ActivatedRoute, Params } from '@angular/router';
import  inventoryRouteMapper  from '../../inventory-route-mapper';
import { Observable } from 'rxjs';
import { RefreshSharedService } from '../../../../refresh-shared-service';

@Component({
    selector: 'inventory-tree-holder',
    providers: [ InventoryService, ContextMenuService, TreeService ],
    styles: [
        require('./inventory-tree-holder.scss')
    ],
    encapsulation: ViewEncapsulation.None,
    template: require('./inventory-tree-holder.html')
})

export class InventoryTreeHolder implements OnChanges {
    @Input() state: any;
    @Input() set url(url: String) {};
    @Input() set linksMap(linksMap: any) {};
    @Input() set actionsMap(actionsMap: any) {};
    @Input() forceReloadTree: any;
    @Input() computeTreeVisible: boolean;

    private baseUrl: String = "/hybridity/api/vcd/inventory/query?";
    private selectedSearchType: any = '1';
    private nodes: any = [];
    private originalNodes: any = [];
    private subscription: Subscription;
    private refresh: Subscription;
    private urlPath: any;
    menuActionMapping = {};
    menuLinksMapping = {};
    nodeToBeSelectedOnLoad: any;

    options = {
        idField: 'vcd.objectId',
        displayField: 'vcd.name',
        childrenField: 'children',
        getChildren: this.getChildren.bind(this),
        getIconClass: this.getIconClass.bind(this),
        isExpandedField: 'expanded',
        hasContextMenu: false,
        contextMenuActionMapping: this.menuActionMapping,
        menuLinksMapping: this.menuLinksMapping,
        typeField: 'entityType',
        leafTypes: ['vm']
    };

    @ViewChild(TreeComponent)
    private tree: TreeComponent;
    private rsService: RefreshSharedService;
    private refreshSubscription: Subscription;

    private idsFromUrl = {
                'item': 'compute',
                'ids': []
            };
    constructor(public inventoryTree: InventoryService,
                private elementRef: ElementRef,
                private renderer: Renderer,
                private treeService: TreeService,
                private router: Router,
                private route: ActivatedRoute,
                private rss: RefreshSharedService) {
              this.rsService = rss;

    }

    ngOnInit() {
        let __this = this;
        this.nodeToBeSelectedOnLoad = location.href.match(/([^\/]*)\/*$/)[1];
        let url = location.href;
        let substring = '/inventory/';
        let pos = url.indexOf(substring);
        
        if (pos !== -1) {
            let locationHref = url.substring(pos + substring.length);
            let locationIds = locationHref.split('/');
            let ids = [];
            for (let i = 1; i < locationIds.length; i += 2) {
                ids.push (locationIds[i]);
            }
             this.idsFromUrl = {
                'item': 'compute',
                'ids': ids
            }
        }

        this.tree.treeService.setIdsFromUrl(this.idsFromUrl);
        this.refreshSubscription = this.rsService.getRefreshParam()
        .subscribe (
        item => {
            this.handleEmittedValues(item);
        });
    }

    handleEmittedValues(item) {
        if (item.shouldReloadInventoryTree) {
            let shouldSelectRoot = (item.target === 'delete') ? true : false;
            this.treeRefresh(this.tree, shouldSelectRoot);
        }
  }

    getElementReference() {
        return this.elementRef;
    }

    ngOnChanges(changes) {
        if (this.forceReloadTree) {
            this.treeRefresh(this.tree, false);
        }
        if( changes && changes.url && changes.url.currentValue && changes.state ) {
            this.loadTree(changes.url.currentValue);
        }
        if( changes && changes.actionsMap && changes.actionsMap.currentValue ) {
            this.menuActionMapping = changes.actionsMap.currentValue;
        }
        if( changes && changes.linksMap && changes.linksMap.currentValue ) {
            this.menuLinksMapping = changes.linksMap.currentValue;
        }
    }

    loadTree(url) {
        this.subscription =
            this.inventoryTree.getTreeNodes(url).subscribe(nodes => {
                    this.nodes = nodes;
                    this.originalNodes = nodes;
                    this.options = {
                        idField: 'vcd.objectId',
                        displayField: 'vcd.name',
                        childrenField: 'children',
                        getChildren: this.getChildren.bind(this),
                        getIconClass: this.getIconClass.bind(this),
                        isExpandedField: 'expanded',
                        hasContextMenu: false,
                        contextMenuActionMapping: this.menuActionMapping,
                        menuLinksMapping: this.menuLinksMapping,
                        typeField: 'entityType',
                        leafTypes: ['vm']
                    };
                },
                error => { console.log('Error on loading tree'); },
                () => {
                     setTimeout(() => {
                         let len = this.idsFromUrl.ids.length;
                         if (len === 0) {
                              this.tree.treeService.selectFirstRoot();
                              localStorage.setItem('computeRoot', this.tree.treeService.getFirstRoot().id);
                         } else {
                             localStorage.setItem('computeRoot', this.nodeToBeSelectedOnLoad);
                            let orgNode = this.tree.treeService.getNodeById(this.idsFromUrl.ids[0]);
                            if (orgNode) {
                                orgNode.blur();
                                orgNode.focus();
                                if (len > 1) {
                                    orgNode.expand();
                                }
                            }
                         } 
                     });
                }
            );
    }

    ngOnDestroy() {
        if( this.subscription ) {
            this.subscription.unsubscribe();
        }
        if( this.refresh ) {
            this.refresh.unsubscribe();
        }
        if( this.refreshSubscription ) {
            this.refreshSubscription.unsubscribe();
        }
        this.rsService.resetParam();
        localStorage.removeItem('computeRoot');
        localStorage.removeItem('lastComputeRoute');
    }

    getChildren(node) {
        // TODO: This has to be a generic file. Should move this code to some place else.
        let childUrl: String;
        if ( node.data.entityType == "org" ) {
            childUrl = this.baseUrl + "entityType=vdc&orgId=" + node.data.vcd.objectId;
        } else if ( node.data.entityType == "vdc" ) {
            childUrl = this.baseUrl + "entityType=vApp&vdcId=" + node.data.vcd.objectId;
        } else if ( node.data.entityType == "vApp" ) {
            childUrl = this.baseUrl + "entityType=vm&vAppId=" + node.data.vcd.objectId;
        }
        return this.inventoryTree.getChildNodes(childUrl);
    }

    getIconClass(node) {
        switch (node.data.entityType) {
            case 'org':
                return 'tree-node-org-icon';
            case 'vdc':
                return 'tree-node-vdc-icon';
            default:
                return 'tree-node-icon';
        }
    }

    getRoutePathParam(idPath: any, namePath: any) {
        let idPathLen = idPath.length;
        let routePath = {'url': '', 'param': ''};
        switch (idPathLen) {
            case 1:
                routePath.url = 'org';
                routePath.param = idPath[0];
                break;
            case 2:
                routePath.url = 'org/'+idPath[0]+'/vdc/';
                routePath.param = idPath[1];
                break;
            case 3:
                routePath.url = 'org/' + idPath[0] + '/vdc/' + idPath[1] + '/vapp/';
                routePath.param = idPath[2];
                break;
            case 4:
                routePath.url = 'org/'+ idPath[0] + '/vdc/' + idPath[1] + '/vapp/' + idPath[2] + '/vm/';
                routePath.param = idPath[3];
        }
        return routePath;
    }

    onNodeSelection = ($event) => {
        if (!this.computeTreeVisible) {
            return;
        }
        let type = $event.node && $event.node && $event.node.data && $event.node.data.entityType ? $event.node.data.entityType : '',
        routePath = inventoryRouteMapper[type],
        id = $event.node && $event.node && $event.node.data && $event.node.data.vcd.objectId ? $event.node.data.vcd.objectId : '';
        let routePathParam = this.getRoutePathParam($event.node.idPath, $event.node.path);
        if (routePathParam.url !== '') {
            let separator = (routePathParam.url.substr(routePathParam.url.length - 1) === '/') ? "" : '/';
            localStorage.setItem('lastComputeRoute', routePathParam.url + separator + routePathParam.param);
            this.router.navigate([routePathParam.url, routePathParam.param ], { relativeTo: this.route });
        }
    };

    onEvent = ($event) => {
    };

    onTreeInit = ($event) => {
    };

    onFocus = ($event) => {
    };

    treeFilter(tree, value) {
        tree.treeService.filterNodes(value, true);
    }

    treeRefresh(tree, shouldSelectRoot = false) {
        let __this = this;
        tree.treeService.prepareRefresh();
        this.refresh = this.inventoryTree.getTreeNodes('/hybridity/api/vcd/inventory/query?entityType=org')
            .subscribe(nodes => {
            this.nodes = nodes;
        },
        error => { console.log('Error on loading tree'); },
        () => {
            if (shouldSelectRoot) { __this.selectFirstRoot();}
            tree.treeService.afterFirstLevelLoad(); 
        });
    }

    selectFirstRoot() {
        this.tree.treeService.selectFirstRoot();
    }

}



// WEBPACK FOOTER //
// ./src/app/components/inventory-main/inventory-tree/tree-holder/inventory-tree-holder.component.ts